//
//
//
//
//
//
//
//

import { getPeriod } from "@/utils/";
export default {
  name: "App",
  created() {
    getPeriod();
  },
};



// WEBPACK FOOTER //
// ./src/App.vue